<template>
  <img alt="Vue logo" src="./assets/logo.svg" />
  <calculator />
</template>

<script>
import { defineComponent } from 'vue';
import calculator from './components/Calculator.vue';

export default defineComponent({
  name: 'App',
  components: {
    calculator,
  },
});
</script>

<style lang="scss">
*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

:root {
  font-size: 75%;
  box-sizing: border-box;
}

body {
  font-family: 'Space Mono', monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: $light-cyan;
}

body,
#app {
  height: 100vh;
}

#app {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @include phone-styles {
    justify-content: space-between;
  }
}

img {
  @include phone-styles {
    margin-top: 4rem;
  }
}
</style>
